import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import * as IoIcons from "react-icons/io";
import {
  obtenerNumeroTrabajadores,
  obtenerRepresentanteLegal,
  trabajadoresPorInstitucion,
} from "../../Services/Rest";
import CreaTrabajadores from "../Modals/crear/CreaTrabajadores";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";

const cookie = new Cookies();

const grupos = ["1", "2", "3"];
const InfoTrabajadores = (props) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "codigoPerfil",
        header: "Nivel De Formación",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "descripcionPerfil",
        header: "Descripción Perfil",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },

      {
        accessorKey: "descripcionOtros",
        header: "Descripción Otros",
        filterVariant: "text",
      },
      {
        accessorKey: "asistenciales",
        header: "Asistenciales",
        filterVariant: "text",
      },
      {
        accessorKey: "administrativas",
        header: "Administrativas",
        filterVariant: "text",
      },
      {
        accessorKey: "asistencialesAdministrativas",
        header: "Asistenciales Administrativas",
        filterVariant: "text",
      },
      {
        accessorKey: "total1",
        header: "Total",
        filterVariant: "text",
      },
      {
        accessorKey: "planta",
        header: "planta",
        filterVariant: "text",
      },
      {
        accessorKey: "prestacionServicios",
        header: "Prestacion Servicios",
        filterVariant: "text",
      },
      {
        accessorKey: "terceros",
        header: "Terceros",
        filterVariant: "text",
      },
      {
        accessorKey: "trabajadoresServicios",
        header: "Trabajadores Servicios",
        filterVariant: "text",
      },
      {
        accessorKey: "otros",
        header: "Otros",
        filterVariant: "text",
      },
      {
        accessorKey: "total2",
        header: "Total",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion",
        header: "Institución",
        filterVariant: "text",
      },

      {
        accessorKey: "fechaCorte",
        header: "Fecha Corte",
        filterVariant: "text",
        enableEditing: false,
      },
    ],
    [],
  );

  const cookie = new Cookies();
  const urlA = obtenerNumeroTrabajadores;
  const urlU = trabajadoresPorInstitucion;

  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaTrabajadores?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleOpenModalTest}>
        {" "}
        Consulta la información
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Información de los Trabajadores
                  </h6>

                  <div className="row"></div>
                  <hr />

                  <a href="../../formatos/FormatoTrabajadores.csv" download>
                    Descargar Formato
                  </a>
                  <hr />
                  <MaterialReactTable
                    localization={MRT_Localization_ES}
                    columns={columns}
                    data={list1}
                    initialState={{ showColumnFilters: true }}
                    enableEditing
                    onEditingRowSave={handleSaveRow}
                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        <Tooltip arrow placement="left" title="Edit">
                          <IconButton onClick={() => table.setEditingRow(row)}>
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default InfoTrabajadores;
